module.exports = __webpack_public_path__ + "img/Responsive.c9d2353e.png";